import { Injectable, Renderer2, RendererFactory2, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { TranslationService } from './translation.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppRedirectService {
    private readonly showSpinnerState = signal<boolean>(false);
    readonly showSpinner$ = toObservable(this.showSpinnerState);
    appStoreLink: string = '';
    playStoreLink: string = '';
    deepLinkUrl: string = '';
    private readonly renderer: Renderer2;
    appStoreRedirectionLink: any;

    constructor(
        private readonly translationService: TranslationService,
        readonly rendererFactory: RendererFactory2,
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public getSmartBannerLinks() {
        this.playStoreLink = this.translationService.cpConfig.playStoreLink;
        this.appStoreLink = this.translationService.cpConfig.appStoreLink;
        this.deepLinkUrl = this.translationService.cpConfig.deepLinkUrl;
        this.appStoreRedirectionLink = this.translationService.cpConfig.appStoreLink;
    }

    public detectAppleDevice(): boolean {
        const userAgent = navigator.userAgent || navigator.vendor;
        return /Mac|iPhone|iPad/.test(userAgent);
    }

    public triggerGoToApp(): void {
        this.getSmartBannerLinks();

        this.showSpinnerState.set(true);

        const redirectUrl = this.detectAppleDevice() ? this.playStoreLink : this.appStoreLink;

        window.location.href = this.deepLinkUrl;

        let appOpened = false;

        const handleVisibilityChange = () => {
            if (document.visibilityState !== 'visible') {
                appOpened = true;
                document.removeEventListener('visibilitychange', handleVisibilityChange);
                this.showSpinnerState.set(false);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        setTimeout(() => {
            if (!appOpened && redirectUrl) {
                window.location.href = redirectUrl;
                this.showSpinnerState.set(false);
            }
        }, 3000);
    }

    public redirectUserToStoreBasedOnDeviceRegion(): void {
        const storeUrl = this.detectAppleDevice() ? this.playStoreLink : this.appStoreLink;
        setTimeout(() => {
            // Page still visible = app NOT installed → store
            if (document.visibilityState === 'visible') {
                if (storeUrl) {
                    window.location.href = storeUrl;
                }
                this.showSpinnerState.set(false);
            }
        }, 3000);
    }

    public openDeepLinkUrls(path: string): void {
    const baseUrl = environment.appRedirectUrl.replace(/\/$/, '');
    const query = new URLSearchParams({ path }).toString();
    const redirectUrl = `${baseUrl}/open-app?${query}`;

    window.open(redirectUrl, '_blank', 'noopener,noreferrer');
    }

    public closeSpinner(): void {
        this.showSpinnerState.set(false);
    }

    checkBannerPresence(): boolean {
        return !!this.renderer.selectRootElement('.banner-area', true);
    }

    private updateSpinnerState(isVisible: boolean): void {
        this.showSpinnerState.set(isVisible);
    }
}
